import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiHandle } from "../config/apiHandle/apiHandle";

// User ticket actions
export const getUserTickets = createAsyncThunk(
  "supportTickets/getUserTickets",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiHandle.get("/tickets");
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const createTicket = createAsyncThunk(
  "supportTickets/createTicket",
  async (ticketData, { rejectWithValue }) => {
    try {
      const response = await apiHandle.post("/tickets/create", ticketData);
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const getTicketById = createAsyncThunk(
  "supportTickets/getTicketById",
  async (ticketId, { rejectWithValue }) => {
    try {
      const response = await apiHandle.get(`/tickets/${ticketId}`);
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const replyToTicket = createAsyncThunk(
  "supportTickets/replyToTicket",
  async ({ ticketId, message }, { rejectWithValue }) => {
    try {
      const response = await apiHandle.post(`/tickets/${ticketId}/reply`, { message });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Admin ticket actions
export const getAdminTickets = createAsyncThunk(
  "supportTickets/getAdminTickets",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      if (filters.status) params.append("status", filters.status);
      if (filters.priority) params.append("priority", filters.priority);
      if (filters.category) params.append("category", filters.category);

      const response = await apiHandle.get(`/admin/tickets?${params.toString()}`);
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const getAdminTicketById = createAsyncThunk(
  "supportTickets/getAdminTicketById",
  async (ticketId, { rejectWithValue }) => {
    try {
      const response = await apiHandle.get(`/admin/tickets/${ticketId}`);
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const adminReplyToTicket = createAsyncThunk(
  "supportTickets/adminReplyToTicket",
  async ({ ticketId, message }, { rejectWithValue }) => {
    try {
      const response = await apiHandle.post(`/admin/tickets/${ticketId}/reply`, { message });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const updateTicketStatus = createAsyncThunk(
  "supportTickets/updateTicketStatus",
  async ({ ticketId, status }, { rejectWithValue }) => {
    try {
      const response = await apiHandle.post(`/admin/tickets/${ticketId}/status`, { status });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);
